import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Card, Typography } from '@mui/material';
import type { MenuStoreMenuListItem } from '../../models/menu-store.entity';
import { ReactComponent as AutoStoriesIcon } from '../../static/images/svg/auto_stories.svg';
import defaultMenuImage from '../../static/images/default-menu.png';
import { formatMenuStoreDate, formatPublisher, resolveMenuStoreCoverImage } from './menu-store.helpers';

type MenuStoreCardProps = {
    /** 菜单卡片数据。 */
    item: MenuStoreMenuListItem;
    /** 打开详情回调。 */
    onOpen: () => void;
};

/**
 * 菜单商店列表卡片（深底 + auto_stories 图标 + 白字）。
 */
export const MenuStoreCard: React.FC<MenuStoreCardProps> = observer((props) => {
    /** 菜单卡片数据。 */
    const { item, onOpen } = props;
    /** 发布人展示文本。 */
    const publisher = formatPublisher(item);
    /** 创建时间展示文本。 */
    const dateLabel = formatMenuStoreDate(item.created_at);
    /** 列表卡片封面图地址（无图时回退默认菜单图）。 */
    const coverImage = resolveMenuStoreCoverImage(item);
    /** 卡片背景最终 URL（主图为空时直接使用默认图）。 */
    const [cardImageUrl, setCardImageUrl] = React.useState<string>(coverImage || defaultMenuImage);
    React.useEffect(() => {
        setCardImageUrl(coverImage || defaultMenuImage);
    }, [coverImage]);
    return (
        <Card className="menu-store-card" onClick={onOpen} elevation={0}>
            <img
                className="menu-store-card__bg"
                src={cardImageUrl}
                alt=""
                aria-hidden
                loading="lazy"
                decoding="async"
                onError={() => {
                    setCardImageUrl(defaultMenuImage);
                }}
            />
            <Box className="menu-store-card__inner">
                <AutoStoriesIcon className="menu-store-card__icon" aria-hidden />
                <Typography variant="subtitle1" component="h3" className="menu-store-card__title" noWrap title={item.name}>
                    {item.name}
                </Typography>
                <Typography variant="body2" className="menu-store-card__meta">
                    {dateLabel}
                </Typography>
                <Typography variant="body2" className="menu-store-card__meta" noWrap title={publisher}>
                    {publisher}
                </Typography>
            </Box>
        </Card>
    );
});
